import Debug from './pages/Debug'
import DashboardIndex from './pages/DashboardIndex'
import CampaignsIndex from './pages/CampaignsIndex'
import CampaignsEdit from './pages/CampaignsEdit'
import CampaignDetails from './pages/CampaignDetails'
import CampaignStages from './pages/CampaignStages'
import CampaignsEditStages from './pages/CampaignsEditStages'
import CampaignHistory from './pages/CampaignHistory'
import CampaignMailQueue from './pages/CampaignMailQueue'
import CampaignMailLogs from './pages/CampaignMailLogs'
import CampaignActions from './pages/CampaignActions'
import TemplatesIndex from './pages/TemplatesIndex'
import TemplatesEdit from './pages/TemplatesEdit'
import UploadEdit from './pages/UploadEdit'
import SendMail from './pages/SendMail'
import Login from './pages/Login'
import Logout from './pages/Logout'
// import TestPage from './pages/TestPage'
import StageDetails from './pages/StageDetails'
import StageTemplate from './pages/StageTemplate'

export default [
  { path: '/', redirect: { name: 'login' }, name: 'home' },
  { path: '/dashboard', component: DashboardIndex, name: 'dashboard-index', meta: { requiresAuth: true } },

  { path: '/campaigns', component: CampaignsIndex, name: 'campaigns-index', meta: { requiresAuth: true } },
  { path: '/campaigns/',
    component: CampaignsEdit,
    meta: { requiresAuth: true },
    children: [
      { path: 'create', component: CampaignDetails, name: 'campaigns-create', meta: { requiresAuth: true } },
      { path: ':id', component: CampaignMailLogs, name: 'campaigns-edit', meta: { requiresAuth: true } },
      { path: ':id/details', component: CampaignDetails, name: 'campaigns-details', meta: { requiresAuth: true } },
      { path: ':id/stages', component: CampaignStages, name: 'campaigns-stages', meta: { requiresAuth: true } },
      { path: ':id/queue', component: CampaignMailQueue, name: 'campaigns-queue', meta: { requiresAuth: true } },
      { path: ':id/actions', component: CampaignActions, name: 'campaigns-actions', meta: { requiresAuth: true } }
    ] },

  { path: '/campaigns/:id/stages/',
    component: CampaignsEditStages,
    meta: { requiresAuth: true },
    children: [
      { path: 'create', component: StageDetails, name: 'campaigns-edit-stages-create', meta: { requiresAuth: true } },
      { path: ':stageid', component: StageDetails, name: 'campaigns-edit-stages-edit', meta: { requiresAuth: true } },
      { path: ':stageid/template', component: StageTemplate, name: 'stage-template', meta: { requiresAuth: true } }
    ] },

  { path: '/campaigns/:id/history', component: CampaignHistory, name: 'campaign-history', meta: { requiresAuth: true } },
  { path: '/campaigns/:id/mail_logs', component: CampaignMailLogs, name: 'campaign-maillogs', meta: { requiresAuth: true } },

  { path: '/templates', component: TemplatesIndex, name: 'templates-index', meta: { requiresAuth: true } },
  { path: '/templates/create', component: TemplatesEdit, name: 'templates-create', meta: { requiresAuth: true } },
  { path: '/templates/:id', component: TemplatesEdit, name: 'templates-edit', meta: { requiresAuth: true } },

  { path: '/upload', component: UploadEdit, name: 'upload-create', meta: { requiresAuth: true } },
  { path: '/send/:id/:resource_type/:resource_id', component: SendMail, name: 'send-mail', meta: { requiresAuth: true } },

  { path: '/login', component: Login, name: 'login' },
  { path: '/logout', component: Logout, name: 'logout' },

  { path: '/debug', component: Debug, name: 'debug' }
]
